// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./imgs/default.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar-module__ui-Avatar--nWt7h {
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 50%;
}

.Avatar-module__ui-Avatar--nWt7h:empty {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.Avatar-module__initial--InSdP {
  display: grid;
  width: 100%;
  height: 100%;
  place-items: center;
  background-color: var(--avatar-initial-background);
  color: var(--avatar-initial-color);
  font-size: var(--avatar-initial-font-size);
  line-height: var(--avatar-initial-line-height);
  letter-spacing: var(--avatar-initial-letter-spacing);
  white-space: nowrap;
}

.Avatar-module__ui-Avatar--nWt7h > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Avatar-module__size-medium--k1dw_ {
  --avatar-initial-background: var(--chaek-color-surface-avatar-detail);
  --avatar-initial-color: var(--chaek-color-text-secondary);
  --avatar-initial-font-size: 12px;
  --avatar-initial-line-height: 18px;
  --avatar-initial-letter-spacing: -0.35px;

  width: 30px;
  height: 30px;
}

.Avatar-module__size-small--Heegj {
  --avatar-initial-background: var(--chaek-color-surface-avatar-home);
  --avatar-initial-color: var(--chaek-color-text-avatar);
  --avatar-initial-font-size: 10px;
  --avatar-initial-line-height: 15px;
  --avatar-initial-letter-spacing: -0.2328px;

  width: 18px;
  height: 18px;
}

.Avatar-module__size-x-small--u3E0V {
  width: 18px;
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Avatar/Avatar.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yDAAyC;EACzC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,kCAAkC;EAClC,0CAA0C;EAC1C,8CAA8C;EAC9C,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qEAAqE;EACrE,yDAAyD;EACzD,gCAAgC;EAChC,kCAAkC;EAClC,wCAAwC;;EAExC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mEAAmE;EACnE,sDAAsD;EACtD,gCAAgC;EAChC,kCAAkC;EAClC,0CAA0C;;EAE1C,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".ui-Avatar {\n  display: inline-block;\n  position: relative;\n  flex-shrink: 0;\n  overflow: hidden;\n  border-radius: 50%;\n}\n\n.ui-Avatar:empty {\n  background-image: url(./imgs/default.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.initial {\n  display: grid;\n  width: 100%;\n  height: 100%;\n  place-items: center;\n  background-color: var(--avatar-initial-background);\n  color: var(--avatar-initial-color);\n  font-size: var(--avatar-initial-font-size);\n  line-height: var(--avatar-initial-line-height);\n  letter-spacing: var(--avatar-initial-letter-spacing);\n  white-space: nowrap;\n}\n\n.ui-Avatar > img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.size-medium {\n  --avatar-initial-background: var(--chaek-color-surface-avatar-detail);\n  --avatar-initial-color: var(--chaek-color-text-secondary);\n  --avatar-initial-font-size: 12px;\n  --avatar-initial-line-height: 18px;\n  --avatar-initial-letter-spacing: -0.35px;\n\n  width: 30px;\n  height: 30px;\n}\n\n.size-small {\n  --avatar-initial-background: var(--chaek-color-surface-avatar-home);\n  --avatar-initial-color: var(--chaek-color-text-avatar);\n  --avatar-initial-font-size: 10px;\n  --avatar-initial-line-height: 15px;\n  --avatar-initial-letter-spacing: -0.2328px;\n\n  width: 18px;\n  height: 18px;\n}\n\n.size-x-small {\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Avatar": `Avatar-module__ui-Avatar--nWt7h`,
	"initial": `Avatar-module__initial--InSdP`,
	"size-medium": `Avatar-module__size-medium--k1dw_`,
	"size-small": `Avatar-module__size-small--Heegj`,
	"size-x-small": `Avatar-module__size-x-small--u3E0V`
};
export default ___CSS_LOADER_EXPORT___;
